import type { UserType } from '@app-types/user';

import { auth } from '@constants/auth';
import { MILLISECONDS_IN_SECOND } from '@constants/time';

import { isPast } from 'date-fns';

export function getServerSession() {
    return auth();
}

export const isSessionExpired = (user: UserType | undefined) => {
    return user?.tokenExp && isPast(user.tokenExp * MILLISECONDS_IN_SECOND);
};
